import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getSalesDashboardData = createAsyncThunk('salesDashboard/data/getSalesDashboardData', async () => {
  // const response = await getDashboardData();
  return dashboardData;
});

export const initialFilterData = {
  status: '',
};

const dataSlice = createSlice({
  name: 'salesDashboard/data',
  initialState: {
    loading: true,
    dashboardData: {},
  },
  reducers: {},
  extraReducers: {
    [getSalesDashboardData.fulfilled]: (state, action) => {
      state.dashboardData = action.payload;
      state.loading = false;
    },
    [getSalesDashboardData.pending]: (state) => {
      state.loading = true;
    },
  },
});

export default dataSlice.reducer;

const dashboardData = {
  statisticData: {
    revenue: {
      value: 21827.13,
      growShrink: 11.4,
    },
    orders: {
      value: 1758,
      growShrink: -3.2,
    },
    purchases: {
      value: 7249.31,
      growShrink: 5.7,
    },
  },
  salesReportData: {
    series: [
      {
        name: 'Online Sales',
        data: [24, 33, 29, 36, 34, 43, 40, 47, 45, 48, 46, 55],
      },
      {
        name: 'Marketing Sales',
        data: [20, 26, 23, 24, 22, 29, 27, 36, 32, 35, 32, 38],
      },
    ],
    categories: ['01 Jan', '02 Jan', '03 Jan', '04 Jan', '05 Jan', '06 Jan', '07 Jan', '08 Jan', '09 Jan', '10 Jan', '11 Jan', '12 Jan'],
  },
  topProductsData: [
    {
      id: '12',
      name: 'Luminaire Giotto Headphones',
      img: '/img/products/product-1.jpg',
      sold: 252,
    },
    {
      id: '14',
      name: 'Black Sneaker',
      img: '/img/products/product-3.jpg',
      sold: 186,
    },
    {
      id: '15',
      name: 'Gray Hoodies',
      img: '/img/products/product-4.jpg',
      sold: 166,
    },
    {
      id: '16',
      name: 'Blue Backpack',
      img: '/img/products/product-5.jpg',
      sold: 93,
    },
    {
      id: '18',
      name: 'Strip Analog Watch',
      img: '/img/products/product-7.jpg',
      sold: 81,
    },
  ],
  latestOrderData: [
    {
      id: '95954',
      date: 1660132800,
      customer: 'Ron Vargas',
      status: 0,
      paymentMehod: 'visa',
      paymentIdendifier: '•••• 6165',
      totalAmount: 168,
    },
    {
      id: '95423',
      date: 1659132800,
      customer: 'Carolyn Hanso',
      status: 0,
      paymentMehod: 'visa',
      paymentIdendifier: '•••• 7128',
      totalAmount: 523,
    },
    {
      id: '92903',
      date: 1658132800,
      customer: 'Gabriella May',
      status: 1,
      paymentMehod: 'paypal',
      paymentIdendifier: '••••@gmail.com',
      totalAmount: 81,
    },
    {
      id: '92627',
      date: 1657332800,
      customer: 'Tara Fletcher',
      status: 2,
      paymentMehod: 'master',
      paymentIdendifier: '•••• 0921',
      totalAmount: 279,
    },
    {
      id: '89332',
      date: 1654132800,
      customer: 'Eileen Horton',
      status: 0,
      paymentMehod: 'paypal',
      paymentIdendifier: '••••@gmail.com',
      totalAmount: 597,
    },
    {
      id: '86497',
      date: 1647632800,
      customer: 'Lloyd Obrien',
      status: 2,
      paymentMehod: 'visa',
      paymentIdendifier: '•••• 0443',
      totalAmount: 189,
    },
    {
      id: '86212',
      date: 1646832800,
      customer: 'Tara Fletcher',
      status: 0,
      paymentMehod: 'paypal',
      paymentIdendifier: '••••@gmail.com',
      totalAmount: 672,
    },
  ],
  salesByCategoriesData: {
    labels: ['Deals', 'Starters', 'Drinks', 'Breakfast'],
    data: [351, 246, 144, 83],
  },
};
